


















import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import MessageArea from '@/views/molecules/MessageArea.vue'

export default
  components: {
    BasePageTemplate
    MessageArea
  }

  data: () ->
    message: [
      'そんな想いから私達は各製造工程を見直し、'
      '生地には抗菌性、吸水速乾性に優れるバンブーレーヨンを'
      '緯糸（よこいと）に使用し、やわらかいストレッチ性もプラス。'
      '切りっぱなしが主流の手ぬぐいの良さを損なわないように'
      '縫製を採用するなど随所にこだわることで'
      'アウトドアシーンや日常使いに最適な'
      '「CHAORAS®のスポーツてぬぐい」が生まれました。'
      'また、使っているうちに風合い良くなった手触りの良さを'
      '使い始めから感じてもらうべく、'
      'ツバキ油を配合した柔軟剤で特殊加工をおこなう、'
      '独自のab･soft®（アブソフト ）加工を施しています。'
    ]

  methods: {
    scrollFire: () ->
      @$emit('scrollFire')
  }
